module.exports = __webpack_public_path__ + "static/media/Uno.6907213f.png";